import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import SearchMenu from './searchMenu';
import { getUserDetails } from '../../../services/common/util';
import { createAudit } from '../../../services/clinicPortalServices/auditService';
import { auditEnums, serviceConstants } from '../../../services/common/constants';
import { ThemeContext } from '../../../theme/ThemeProvider';
import { getImportHistory } from '../../../services/clinicPortalServices/resultImportService.js';
import moment from 'moment';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import { capitalize } from 'lodash';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class ResultImportHistoryGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'File Name',
                    minWidth: 350,
                    resizable: true,
                    field: 'filename'
                },
                {
                    headerName: 'Total Records',
                    minWidth: 150,
                    resizable: true,
                    field: 'total_records'
                },
                {
                    headerName: 'Processed Records',
                    minWidth: 150,
                    resizable: true,
                    field: 'processed_records'
                },
                {
                    headerName: 'Processed QC Result Records',
                    minWidth: 150,
                    resizable: true,
                    field: 'processed_qc_result_records'
                },
                {
                    headerName: 'Skipped Records',
                    minWidth: 150,
                    resizable: true,
                    field: 'failed_records'
                },
                {
                    headerName: 'Status',
                    minWidth: 150,
                    resizable: true,
                    field: 'status',
                    valueGetter: (params) => {
                        return capitalize(params.data.status);
                    }
                },
                {
                    headerName: 'Uploaded At',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return moment
                            .tz(params.data.uploaded_at, serviceConstants.SYSTEM_TIME_ZONE)
                            .format('MM/DD/YYYY hh:mm:ss A');
                    }
                }
            ],
            components: {},
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this },
            qcRanges: []
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridData();
    };

    loadGridData = () => {
        getImportHistory().then((res) => {
            this.setState({ rowData: res.data });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'Result_Import_History_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'Result Import History'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.ResultImportHistoryGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.ResultImportHistoryGridExported
        };
        createAudit(auditData);
    };

    render() {
        let columnDefs = this.state.columnDefs;
        return (
            <div className="clinic-contain">
                <SearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    context={this.state.context}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default ResultImportHistoryGrid;
